/**
 * Formatea el JSON de payload/respuesta del historial de sync de inventario.
 */
export function formatInventorySyncJson(raw: string | null | undefined): string {
  if (!raw) {
    return '(sin datos)';
  }

  try {
    return JSON.stringify(JSON.parse(raw), null, 2);
  } catch {
    return raw;
  }
}
